import styles from './styles.module.css';
import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';

import aboutImg from "src/assets/images/home/about/about.webp";

import { isRTL } from 'src/utils/global';
import { data } from './data';

const About = () => {
    const { t, i18n } = useTranslation("home");
    const currentLang = i18n.language as 'ar' | 'en';

    return (
        <Element data-aos="fade-up" name="aboutUs" className={`${styles.about} ${isRTL() && styles.rtl}`}>
            <div className='container'>
                <div className={'row'}>
                    <div className='col-lg-5 d-flex align-items-center'>
                        <div className={styles.img__con}>
                            <img
                                src={aboutImg}
                                alt={t("about.title")}
                                width={460}
                                height={240}
                                loading='lazy'
                            />
                        </div>
                    </div>
                    <div className='col-lg-7 my-auto'>
                        <div className={styles.subTitle}>
                            {t("about.sub_title")}
                        </div>
                        <h2 className={styles.title}>
                            {t("about.title")}
                        </h2>
                        <p className={`${styles.about__text} global-p`}>
                            {t("about.content")}
                        </p>
                    </div>
                    <div className='col-12'>
                        <div className="row mt-5">
                            {data.map((item, index) => (
                                <div
                                    key={`feature-key-${index}`}
                                    className="col-lg-4 col-md-6 col-12 mx-auto px-2"
                                    data-aos="fade-up"
                                    data-aos-delay={index * 80} // delay each card by 150ms
                                >
                                    <div className={styles.card}>
                                        <item.icon className={styles.icon} size={92} />
                                        <h4>{item.title[currentLang]}</h4>
                                        <p className='global-p'>{item.content[currentLang]}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>

            </div>
        </Element>
    )
}

export default About;
